import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { EditProductCategory, GetCategoryById, GetCategoryImage, GetProductStatus, api_url, } from '../apiconfig/authService';

function EditCategory(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  console.log(props);
  const setCategoryViewMessage = props.setMessage;

  const [categoryData, setCategoryData] = useState({});
  const [editedCategoryData, setEditedCategoryData] = useState({});
  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState(false);
  const { categoryid } = useParams();
  const [fetchCategoryData, setFetchCategoryData] = useState(false);
  const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const imageInputRef = React.createRef();

  console.log(categoryData);

  useEffect(() => {
    (
      async () => {
        try {
          const response = await GetCategoryById(categoryid, localStorage.getItem('accessToken'));
          setCategoryData(response.data.productCategory._doc);
          setEditedCategoryData(response.data.productCategory._doc);
        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, [fetchCategoryData]);

  useEffect(() => {
    (
      async () => {
        try {
          const statusResponse = await GetProductStatus(localStorage.getItem('accessToken'));
          setStatusData(statusResponse.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, []);

  const handleNameChange = (e) => {
    const temp = { ...editedCategoryData };
    temp.name = e.target.value;
    setEditedCategoryData(temp);
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };

  const handleDiscardClick = async () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
    setNewImage(null);
    const temp = { ...categoryData };
    setEditedCategoryData(temp);
  };

  const handleStatusChange = (e) => {
    const temp = { ...editedCategoryData };
    temp.statusid = e.target.value;
    setEditedCategoryData(temp);
  };

  const validateInput = () => {
    if (editedCategoryData.name === '')
      throw new Error('Name is required.');
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append('categoryid', editedCategoryData.categoryid);
    formData.append('name', editedCategoryData.name);
    formData.append('statusid', editedCategoryData.statusid);
    if (newImage) {
      formData.append('image', newImage);
      formData.append('imagename', editedCategoryData.image);
    }

    try {
      response = await EditProductCategory(formData,localStorage.getItem('accessToken'));
      if (response.status === 200) {
        setCategoryViewMessage(response.data.message);
        navigate('/category');
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
      console.log(err);
    }

  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Category</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/category" className="btn btn-primary">View All</NavLink>
          </div>
        </div>

        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}

        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={editedCategoryData?.name} onChange={handleNameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Name</label>
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating mb-4">
                  <input type="file" ref={imageInputRef} className="form-control" id="catImg" onChange={handleImageChange} placeholder="Product Main Category Image" />
                  <label htmlFor="catImg">Image</label>
                  <img width="100px" height="100px" src={`${api_url}/product/category/getCategoryImage/${editedCategoryData?.image}`} />
                </div>
              </div>
              <div className="form-floating mb-4">
                <select className="form-select" onChange={handleStatusChange} value={editedCategoryData?.statusid} >
                  {
                    statusData?.map((item) => (
                      <option value={item.statusid}>
                        {item.status}
                      </option>
                    ))
                  }
                </select>
                <label htmlFor="floatingInput">Status</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button type="submit" onClick={handleDiscardClick} className="btn btn-danger btn-lg save-btn text-uppercase">Discard</button> &nbsp;
              <button type="submit" onClick={handleSubmitClick} className="btn btn-primary btn-lg save-btn text-uppercase">Save</button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default EditCategory;
